import { Component, inject, input, OnDestroy, OnInit } from '@angular/core';
import { IconComponent } from '@app2/shared/components/icon/icon.component';
import { DialogModule } from '@app/services/dialog/dialog.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { debounceTime, Subject } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Popover } from 'primeng/popover';
import { SearchWidgetFacade } from '@app2/features/search-widget/search-widget.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { AnalystService } from '@app/services/analyst/analyst.service';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';

@UntilDestroy()
@Component({
  selector: 'sens-search-widget',
  standalone: true,
  imports: [
    IconComponent,
    DialogModule,
    DirectivesModule,
    Popover,
    RouterLink,
  ],
  templateUrl: './search-widget.component.html',
  styleUrl: './search-widget.component.scss',
  providers: [SearchWidgetFacade],
})
export class SearchWidgetComponent implements OnInit, OnDestroy {

  private searchSubject = new Subject<string>();

  private readonly debounceTimeMs = 300; // Set the debounce time (in milliseconds)

  private facade = inject(SearchWidgetFacade);

  private router = inject(Router);

  private analystService = inject(AnalystService);

  private activatedRoute = inject(ActivatedRoute);

  public queryParams = toSignal(this.activatedRoute.queryParams);

  public faps$ = this.facade.faps$;

  public isLoading = this.facade.isLoading;

  public query$ = this.facade.query$;

  public ref$ = input<any>();

  public ngOnInit() {
    // console.log(this.queryParams());
    this.defaultSearch(this.queryParams()?.['q'] ?? '');
    this.searchSubject.pipe(
      untilDestroyed(this),
      debounceTime(this.debounceTimeMs),
    ).subscribe((searchValue) => {
      this.defaultSearch(searchValue);
    });

  }

  onSearchClear() {
    this.searchSubject.next('');
  }

  public defaultSearch(q: string): void {
    this.facade.getFaps(q);
  }

  public onSearchInput($event: Event): void {
    const value = ($event.target as HTMLInputElement).value;
    this.searchSubject.next(value);
  }

  ngOnDestroy() {
    this.searchSubject.complete();
  }


  onSearchKeydown(query: string) {
    this.analystService.logEvent(AnalyticsEventsEnum.SearchTap, {
      query,
    }).then();
    this.router.navigate(['/search'], { queryParams: { q: query } }).then();
  }
}
